import type {
  BillingLocationData,
  CodingScreenState
} from '../../project_starburst/interface';

export const injectFacilityPermission = (
  state: CodingScreenState,
  permission: 'allowed' | 'denied'
): CodingScreenState => {
  const billingLocation = state?.values?.['case.billingLocation'] as
    | BillingLocationData
    | undefined;
  if (!billingLocation) return state;
  return {
    ...state,
    values: {
      ...state.values,
      'case.billingLocation': { ...billingLocation, permission }
    }
  };
};
